import styled from 'styled-components'
import { Grid, Box, Flex, Text } from 'vvs-uikit'

export const Page = styled(Flex)`
  flex: 1;
  flex-direction: column;
`
export const Banner = styled(Flex)<{ bgImg: string }>`
  width: 100%;
  background-image: url('${({ bgImg }) => bgImg}');
  background-size: cover;
  background-position: center;
  padding: 16px 15px;
`
export const BannerContent = styled(Flex)`
  flex: 1;
  position: relative;
  justify-content: center;
  align-items: center;
`
export const CloseBtnWrapper = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
`
export const FaqContent = styled(Box)`
  flex: 1;
  width: 100%;
  background: ${({ theme }) => theme.colors.paleYellow};
`
FaqContent.defaultProps = { pt: '40px', px: '15px' }

export const FaqTitle = styled(Text)`
  font-size: 28px;
  line-height: 36px;
  color: black;
  font-weight: 600;
  margin-bottom: 48px;
`

export const SectionTitle = styled(Text)`
  font-size: 28px;
  line-height: 36px;
  color: ${({ theme }) => theme.colors.blue};
  font-weight: 600;
  margin-bottom: 48px;

  &:not(:first-child) {
    margin-top: 30px;
  }
`

export const QuestionText = styled(Text)`
  color: black;
  font-size: 20px;
  font-weight: 600;
`

export const AnswerUl = styled.ul`
  list-style-position: outside;
  padding: 8px 0 8px 25px;
  color: ${({ theme }) => theme.colors.darkGrey};

  & > li {
    margin: 8px 0;
    line-height: 24px;

    &::marker {
      font-size: 13px;
    }
  }
`
export const AnswerSubUl = styled(AnswerUl)`
  margin: -10px 0 -5px 0;
  padding: 1px 0 1px 20px;
  & > li {
    margin: 4px 0;
  }
`

export const Hr = styled.hr`
  margin: 32px 0;
  border: ${({ theme }) => theme.colors.grey} solid 0.5px;
`

export const StyledTable = styled.table`
  width: 345px;
  transform: translateX(-13px);

  tr {
    border-bottom: 1px solid lightgray;
  }
  tr:last-child {
    border-bottom: none;
  }
  tr:first-child {
    border-bottom: 1px solid lightgray;
  }

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 457px;
    transform: unset;
  }
`
export const StyledRow = styled.tr`
  td,
  th {
    padding-top: 24px;
    padding-bottom: 24px;
    border-right: 1px solid lightgray;
  }

  td {
    text-align: center;
  }
  td:first-child {
    text-align: unset;
  }

  td:last-child,
  th:last-child {
    border-right: none;
  }
`
export const StyledImage = styled.img`
  height: 6px;
  width: 258.94px;

  ${({ theme }) => theme.mediaQueries.sm} {
    width: 343px;
  }
`
export const StyledGrid = styled(Grid)`
  transform: translateX(-10px);

  ${({ theme }) => theme.mediaQueries.sm} {
    transform: unset;
  }
`
